/*@ngInject*/
const ManageOrganizationMediator = function (organizationBrowserActionRepository, organizationRepository, organizationStateModel) {

    this.loadOrganizationList = function (params) {
        return organizationRepository.loadOrganizationList(params);
    };

    this.createNewOrganization = function (organizationType) {
        return organizationRepository.createNewOrganization(organizationType);
    };

    this.savePreviousOrganization = function (id, organizationType, formId) {
        organizationStateModel.savePreviousOrganization(id, organizationType, formId);
    };

    this.getPreviousOrganization = function () {
        return organizationStateModel.getPreviousOrganization();
    };

    this.saveViewState = function (stateName, stateModel) {
        organizationStateModel.saveViewState(stateName, stateModel);
    };

    this.restoreViewState = function (stateName, viewModel) {
        return organizationStateModel.restoreViewState(stateName, viewModel);
    };

    this.getPreviousViewState = function (stateName) {
        return organizationStateModel.getPreviousViewState(stateName);
    };

    this.hasPreviousOrganization = function () {
        return organizationStateModel.hasPreviousOrganization();
    };

    this.resetPreviousOrganization = function () {
        return organizationStateModel.resetPreviousOrganization();
    };

    this.loadOrganizationActions = function (organizationType, organizationId) {
        return organizationBrowserActionRepository.loadActions(organizationType, organizationId);
    };

    this.loadOrganizationById = function (organizationId) {
        return organizationRepository.loadOrganizationById(organizationId);
    };

    this.closeOrganizationPersistentConnection = function (organizationId) {
        return organizationRepository.closeOrganizationPersistentConnection(organizationId);
    };

    this.upgradeForms = function (organizationId) {
        return organizationRepository.upgradeForms(organizationId);
    };

    this.getForms = function (organizationId) {
        return organizationRepository.getForms(organizationId);
    };
};

angular.module('ums.configuration')
    .service('manageOrganizationMediator', ManageOrganizationMediator);
